import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { CHART_PALETTE } from "@/lib/chart-theme";

interface ChartCardProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  /** Height of the body area. Defaults to a 288px (h-72) chart well. */
  bodyClassName?: string;
  className?: string;
  children: React.ReactNode;
}

/** Card shell with a bordered header — matches the prado insights cards. */
export function ChartCard({ title, subtitle, action, bodyClassName, className, children }: ChartCardProps) {
  return (
    <Card className={cn("min-w-0", className)}>
      <CardHeader className="flex flex-row items-center justify-between gap-3 pb-4">
        <div className="min-w-0">
          <CardTitle className="font-heading text-base">{title}</CardTitle>
          {subtitle && <p className="mt-0.5 truncate text-xs text-muted-foreground">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </CardHeader>
      <div className={cn("px-4 py-4", bodyClassName)}>{children}</div>
    </Card>
  );
}

/** @deprecated import `CHART_PALETTE` / `paletteOf` from "@/lib/chart-theme". */
export const CHART_COLORS = [...CHART_PALETTE];
